import alertCall from "../components/@self/CustomAlert";
import { get, post } from "./context/API";
import { getUrl } from "./context/Config";
import { getDecryptedItem } from "./encryptedStorage";

import cloneDeep from "lodash/cloneDeep";

const CONFIG = getUrl();
const BASE_URL = CONFIG.URL.FILESERVICE;
const CONNECTOR_URL = CONFIG.URL.CONNECTOR_FILESERVICE

const blobToBase64 = (blob) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};

export const uploadFile = (fileObject) => {
  const url = BASE_URL.POST;
  try {
    const formData = new FormData();
    formData.append("file", fileObject, fileObject.name);
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    return new Promise((resolve, reject) => {
      post(url, formData, config)
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((e) => {
          alertCall("upload error while uploading file", "danger");
          reject(e);
        });
    });
  } catch (error) {
    console.log("err");
    alertCall(
      error?.errorMessage || "upload error while uploading file",
      "danger"
    );
  }
};

export const downloadFile = (fileObject) => {
  if (!fileObject) {
    return Promise.reject(new Error("No file object provided"));
  }

  if (fileObject) {
    const { id } = fileObject;
    const downloadUrl = BASE_URL.GET.replace("$id", id);

    try {
      return new Promise((resolve, reject) => {
        get(downloadUrl, { responseType: "blob" })
          .then((response) => {
            const blob = new Blob([response.data], {
              type: response.data.type,
            });
            return blobToBase64(blob);
          })
          .then((base64Data) => {
            resolve(base64Data);
          })
          .catch((e) => {
            reject(e);
          });
      });
    } catch (err) {
      console.log("file download error");
      return Promise.reject(err);
    }
  }
};

export const uploadFileWorkbench = (fileObject) => {
  const loginData = JSON.parse(getDecryptedItem("data"));
  const userInfo = cloneDeep(loginData || {});

  const url =
    BASE_URL.POST_WORKBENCH_UPLOAD +
    `?organisationId=${userInfo?.organisationId}`;
  try {
    const formData = new FormData();
    formData.append("file", fileObject, fileObject.name);
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    return new Promise((resolve, reject) => {
      post(url, formData, config)
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((e) => {
          alertCall("upload error", "danger");
          reject(e);
        });
    });
  } catch (err) {
    console.log("err");
    alertCall("upload error", "danger");
  }
};

export const downloadFileWorkbench = (fileObject) => {
  if (!fileObject) {
    return Promise.reject(new Error("No file object provided"));
  }

  if (fileObject) {
    const downloadUrl = BASE_URL.POST_WORKBENCH_DOWNLOAD + "/" + fileObject?.id;

    try {
      return new Promise((resolve, reject) => {
        get(downloadUrl, { responseType: "blob" })
          .then((response) => {
            const blob = new Blob([response.data], {
              type: response.data.type,
            });
            return blobToBase64(blob);
          })
          .then((base64Data) => {
            resolve(base64Data);
          })
          .catch((e) => {
            reject(e);
          });
      });
    } catch (err) {
      console.log("file download error");
      return Promise.reject(err);
    }
  }
};

export const downloadFileHistory = (fileObject) => {
  if (!fileObject) {
    return Promise.reject(new Error("No file object provided"));
  }

  if (fileObject) {
    const { id } = fileObject;
    const downloadUrl = BASE_URL.GET.replace("$id", id);

    try {
      return new Promise((resolve, reject) => {
        get(downloadUrl, { responseType: "blob" })
          .then((response) => {
            const downloadLink = document.createElement("a");
            downloadLink.href = window.URL.createObjectURL(response.data);

            const fileName = `Invoice-${
              new Date().getMonth() + 1
            }-${new Date().getFullYear()}`;

            downloadLink.setAttribute("download", fileName);

            document.body.appendChild(downloadLink);
            downloadLink.click();

            setTimeout(() => {
              URL.revokeObjectURL(downloadLink.href);
              downloadLink.parentNode.removeChild(downloadLink);
            }, 0);
          })
          .then((base64Data) => {
            resolve(base64Data);
          })
          .catch((e) => {
            reject(e);
          });
      });
    } catch (err) {
      console.log("file download error");
      return Promise.reject(err);
    }
  }
};

export const uploadFileIntelliConnect = (fileObject) => {
  const url = CONNECTOR_URL.POST;
  try {
    const formData = new FormData();
    formData.append("file", fileObject, fileObject.name);
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    return new Promise((resolve, reject) => {
      post(url, formData, config)
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((e) => {
          alertCall("upload error while uploading file", "danger");
          reject(e);
        });
    });
  } catch (error) {
    console.log("err");
    alertCall(
      error?.errorMessage || "upload error while uploading file",
      "danger"
    );
  }
};